export default __webpack_public_path__ + "static/media/asfalto.a2089af3.png";